import CurrencyCellProps from './type';
import { formatCurrency } from '../../../utils';
import colors from '../../../theme/colors/colors';
import { CurrencyCellStyled } from './styled';

const CurrencyCell = ({ ...props }: CurrencyCellProps) => {
  const { value, debtCell, hasColor, style, ...rest } = props;
  const getCurrencyColor = (): string => {
    const { green500: greenTucar, error500: redTucar } = colors || {};
    if (!hasColor || typeof value !== 'number') return 'inherit';
    if (debtCell) return value <= 0 ? greenTucar : redTucar;
    return value >= 0 ? greenTucar : redTucar;
  };
  return (
    <CurrencyCellStyled style={{ color: getCurrencyColor(), ...style }} {...rest}>
      {formatCurrency(value, { isDebt: debtCell })}
    </CurrencyCellStyled>
  );
};

CurrencyCell.defaultProps = {
  value: 0,
  hasColor: true,
  debtCell: false,
};

export default CurrencyCell;
